// extracted by mini-css-extract-plugin
export default {"partnersDiv":"Partners_partnersDiv__FhroM","imgDiv":"Partners_imgDiv__70oHB","partnersSlider":"Partners_partnersSlider__w3o3K"};